"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1427],{

/***/ 41427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48641);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);





var NltContentInfo = function NltContentInfo(_ref) {
  var title = _ref.title,
      description = _ref.description,
      asHtml = _ref.asHtml;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
    bg: "white",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, {
      as: _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Stack */ .Kq,
      maxW: "6xl",
      py: 10,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
        as: "h3",
        align: "left",
        color: "baseDark",
        fontFamily: "Montserrat-SemiBold",
        fontSize: "1.375rem",
        letterSpacing: "0.6px",
        lineHeight: "26px",
        whiteSpace: "pre-wrap",
        children: title
      }), asHtml ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
        textAlign: "left",
        color: "baseNeutral.700",
        fontFamily: "Montserrat-Medium",
        fontSize: "1rem",
        letterSpacing: "0.2px",
        whiteSpace: "pre-wrap",
        pb: "l",
        className: "landing-text",
        dangerouslySetInnerHTML: {
          __html: description
        }
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
        textAlign: "left",
        color: "baseNeutral.700",
        fontFamily: "Montserrat-Medium",
        fontSize: "1rem",
        letterSpacing: "0.2px",
        whiteSpace: "pre-wrap",
        mt: "m",
        pb: "l",
        children: description
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["default"] = (NltContentInfo);

/***/ })

}]);